import { selectOfferFormattedAreaParts } from './selectOfferFormattedAreaParts';
import { IState } from '../../store';

export function selectIsOfferWithMultiAds(state: IState) {
  const formattedAreaParts = selectOfferFormattedAreaParts(state);

  return !!(formattedAreaParts && formattedAreaParts.parts && formattedAreaParts.parts.length > 0);
}
